export default __webpack_public_path__ + "static/media/donut.3b7be1c6.png";